<template>
    <SideFormSection>
        <template #title> Profile Information </template>
        <template #rawContent>
            <Card
                title="Profile Information"
                iconName="user"
            >
                <template #content>
                    <ApiForm
                        :url="RoutePathAppEnum.MyProfile_Update"
                        method="POST"
                        ref="apiFormRef"
                        :key="formKey"
                    >
                        <div class="space-y-2">
                            <UserForm
                                :user="localUser"
                                :companyUser="localCompanyUser"
                                :readonly="readonly"
                                :errors="
                                    apiFormRef?.response?.getErrors() ??
                                    new ApiFormErrors({})
                                "
                            />
                        </div>
                    </ApiForm>
                </template>
                <template
                    v-if="!readonly"
                    #actions
                >
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import User from '@/App/User/Entity/User'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Card from '@/Shared/Component/Card.vue'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import UserForm from '@/App/User/Component/UserForm.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const props = defineProps({
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    })

    const formKey = ref<number>(0)
    const apiFormRef = ref<ApiFormRefType>(null)
    const localUser = ref<User>(props.user)
    const localCompanyUser = ref<CompanyUser>(props.companyUser)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                const companyUserAggregate =
                    response.getHydratedCompanyUserAggregate(
                        ResponseJsonKeyEnum.App_User_UpdateProfile_CompanyUserAggregateData,
                    )
                localUser.value = companyUserAggregate.user
                localCompanyUser.value = companyUserAggregate.companyUser
            })
            ?.finally(() => {
                formKey.value += 1
            })
    }
</script>
